import React, { memo, useMemo } from 'react'
import { Chip } from 'src/components/shared/Chip'
import { colors } from 'src/theme'
import tw from 'twin.macro'
import { MCStatus } from 'src/constants/mc/enums'
import { mcStatusTitles } from 'src/constants/mc/constants'

type Status = MCStatus | 'pending'

interface Props {
  status: Status
}

const contractorStatusMap = {
  [MCStatus.Activated]: {
    color: colors.COLORS_GREEN_500,
    text: mcStatusTitles[MCStatus.Activated],
    bgStyle: tw`bg-[rgba(230, 249, 233, 1)]`,
  },
  [MCStatus.Deactivated]: {
    color: colors.COLORS_RED_500,
    text: mcStatusTitles[MCStatus.Deactivated],
    bgStyle: tw`bg-[rgba(255, 232, 238, 1)]`,
  },
  [MCStatus.Invited]: {
    color: colors.SHADES_GREY_500,
    text: mcStatusTitles[MCStatus.Invited],
    bgStyle: tw`bg-[#EDEDED]`,
  },
  [MCStatus.Rejected]: {
    color: colors.COLORS_RED_500,
    text: mcStatusTitles[MCStatus.Rejected],
    bgStyle: tw`bg-[rgba(255, 232, 238, 1)]`,
  },
  pending: {
    color: colors.COLORS_BLUE_500,
    text: mcStatusTitles.pending,
    bgStyle: tw`bg-[#D8E5FF]`,
  },
}

const getMCStatusParams = (status: Status) =>
  contractorStatusMap[status] || {
    color: colors.SHADES_GREY_500,
    text: status,
    bgStyle: tw`bg-[rgba(218, 217, 224, 1)]`,
  }

const MCStatusChipComponent = ({ status }: Props) => {
  const params = useMemo(() => getMCStatusParams(status), [status])

  return (
    <div css={tw`flex items-center`}>
      <div css={tw`px-2 py-1 rounded-[10px]`}>
        <Chip className={params.bgStyle} textColor={params.color} text={params.text} />
      </div>
    </div>
  )
}

export const MCStatusChip = memo(MCStatusChipComponent)
